import { signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut, GoogleAuthProvider, signInWithPopup } from 'firebase/auth'
import { doc, getDoc, setDoc } from 'firebase/firestore'
import { auth, db } from '@/config/firebase'
import type { User } from '@/types'

export const authService = {
  async signInWithGoogle() {
    const provider = new GoogleAuthProvider()
    const result = await signInWithPopup(auth, provider)
    return result.user
  },

  async signIn(email: string, password: string) {
    const userCredential = await signInWithEmailAndPassword(auth, email, password)
    return userCredential.user
  },

  async signUp(email: string, password: string, _displayName: string) {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password)
    return userCredential.user
  },

  async signOut() {
    await signOut(auth)
  },

  async getUserData(uid: string): Promise<User | null> {
    const userDoc = await getDoc(doc(db, 'users', uid))
    if (!userDoc.exists()) return null
    return { id: userDoc.id, ...userDoc.data() } as User
  },

  async updateUserData(uid: string, data: Partial<User>) {
    await setDoc(doc(db, 'users', uid), data, { merge: true })
  },

  async sendPasswordResetEmail(email: string) {
    const { sendPasswordResetEmail: firebaseReset } = await import('firebase/auth')
    await firebaseReset(auth, email)
  },
}

